<div class="flex-row flex-section container content mt-5">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="flex-0 image-div">
    <img class="product-image" [src]="profileImage" />
  </div>

  <div class="flex-1">

    <div class="product-description">
      <span class="sub"><strong>{{selectedServicePlan?.serviceTypeModel?.name}}</strong></span>

      @if (selectedServicePlan?.serviceProviderModel?.businessName != null) {
        <div>
          <h1 class="mt-3" style="font-family: Baloo 2">
            {{ selectedServicePlan.serviceProviderModel.businessName }}
          </h1>
          <p>
            <button style="border-radius: 4px" mat-raised-button color="primary" (click)="navigateToProfilePage()">View Profile</button>
          </p>
        </div>
      }

      @if (selectedServicePlan?.serviceProviderModel?.businessName == null) {
        <div>
          <h1>
            {{selectedServicePlan?.serviceProviderModel?.firstName + " " + selectedServicePlan?.serviceProviderModel?.lastName}}
          </h1>
        </div>
      }
      <mat-divider></mat-divider>
      <p class="mt-2">
        {{ selectedServicePlan?.description }}
      </p>
      <mat-divider></mat-divider>
      <p class="mt-2">
        Provider Location: {{ selectedServicePlan?.serviceProviderModel?.city }}, {{selectedServicePlan?.serviceProviderModel?.state}} {{selectedServicePlan?.serviceProviderModel?.zipCode}}
      </p>
    </div>

    <div class="product-configuration">
      <div class="flex-row mb-3">
        <div class="flex-0 ml-3">
          @if (!selectedServicePlan?.inOfficeAvailability) {
            <mat-icon class="error">clear</mat-icon>
          }

          @if (selectedServicePlan?.inOfficeAvailability) {
            <mat-icon class="success">check</mat-icon>
          }

          <div class="align-self-center product-view-text">
            &nbsp;In Office Availability
          </div>
        </div>

        <div class="flex-0 ml-3">
          @if (!selectedServicePlan?.virtualAvailability) {
            <mat-icon class="error">clear</mat-icon>
          }

          @if (selectedServicePlan?.virtualAvailability) {
            <mat-icon class="success">check</mat-icon>
          }

          <div class="align-self-center product-view-text">
            &nbsp;Virtual Availability
          </div>
        </div>

        <div class="flex-0 ml-3">
          @if (!selectedServicePlan?.homeCareAvailability) {
            <mat-icon class="error">clear</mat-icon>
          }

          @if (selectedServicePlan?.homeCareAvailability) {
            <mat-icon class="success">check</mat-icon>
          }

          <div class="align-self-center product-view-text">
            &nbsp;Home Care Availability
          </div>
        </div>
      </div>

      <div class="flex-row mb-3">
        <div class="flex-0 ml-3 hsaContainer">
          @if (!selectedServicePlan?.hsaApproved) {
            <mat-icon class="error">clear</mat-icon>
          }

          @if (selectedServicePlan?.hsaApproved) {
            <mat-icon class="success">check</mat-icon>
          }

          <div class="align-self-center product-view-text">
            &nbsp;HSA Approved
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      @if (!selectedServicePlan?.unlimitedQuantity) {
        <div>
          <p class="mt-3 product-view-text">Quantity Available: {{selectedServicePlan?.quantityAvailable}}</p>
          <mat-divider></mat-divider>
        </div>
      }

      <form [formGroup]="addToCartFormGroup">
        @if (selectedServicePlan?.appointmentType != 'Subscription') {
          <mat-form-field class="mt-3 ml-2" appearance="outline">
            <mat-label>Appointments to Purchase</mat-label>
            <input type="number" matInput formControlName="quantitySelect" [errorStateMatcher]="matcher" WholeNumberDirective/>
            @if (addToCartFormGroup.controls.quantitySelect.hasError('max')) {
              <mat-error>
                Cannot enter number more than available appointments
              </mat-error>
            }
            @if (addToCartFormGroup.controls.quantitySelect.hasError('min')) {
              <mat-error>
                Must enter a number more than 0
              </mat-error>
            }
            @if (addToCartFormGroup.controls.quantitySelect.hasError('required')) {
              <mat-error>
                Please select a quantity
              </mat-error>
            }
          </mat-form-field>
        }

          <mat-form-field class="ml-2 mt-3" appearance="outline">
            <mat-label>Appointment Location</mat-label>

            <mat-select (selectionChange)="selectAppointmentType($event)" formControlName="appointmentTypeSelect">
              @for (appointmentType of availableAppointmentTypes; track appointmentType) {
                <mat-option [value]="appointmentType">{{ appointmentType }}</mat-option>
              }
            </mat-select>

            @if (addToCartFormGroup.controls.appointmentTypeSelect.hasError('required')) {
              <mat-error class="product-view-text">
                Please Select Appointment Location
              </mat-error>
            }
          </mat-form-field>

        @if (addToCartFormGroup.controls.appointmentTypeSelect.pristine) {
          <p class="error mt-2 product-view-text">
            *Please Select Appointment Location
          </p>
        }
      </form>

      @if (selectedServicePlan?.appointmentType != 'Subscription') {
        <div class="product-price mt-4">
          <span>${{ (selectedServicePlan?.rate ?? 0).toFixed(2) }} per {{ selectedServicePlan?.appointmentType }} appointment</span>
        </div>
      }

      @if (selectedServicePlan?.appointmentType == 'Subscription') {
        <div class="product-price mt-4">
          <span>${{ (selectedServicePlan?.rate ?? 0).toFixed(2) }} per {{ selectedServicePlan?.paymentOccurrence }} Subscription</span>
        </div>
      }

      <mat-divider class="mt-3 mb-4"></mat-divider>

      @if (selectedServicePlan?.appointmentType != 'Subscription') {
        <div>
                <button style="border-radius: 4px" mat-raised-button class="mr-2 mt-3 add-btn" color="primary" [hidden]="(selectedServicePlan?.quantityAvailable == 0 && selectedServicePlan?.unlimitedQuantity == false)" [disabled]="addToCartFormGroup.controls.quantitySelect.hasError('required') ||
                    addToCartFormGroup.controls.quantitySelect.hasError('min') ||
                    addToCartFormGroup.controls.quantitySelect.hasError('max') ||
                    addToCartFormGroup.controls.appointmentTypeSelect.hasError('required') ||
                    addToCartFormGroup.controls.appointmentTypeSelect.pristine" (click)="addToCart(selectedServicePlan)">
            Add to Cart
          </button>
        </div>
      }

      @if (selectedServicePlan?.appointmentType == 'Subscription') {
        <div>
          <a [href]="termsLink" target="_blank">View Terms and Conditions</a>
          <div class="mt-3">
            <mat-checkbox style="color: black;" [formControl]="agreeToTermsForm"><div style="padding-top: 8px;">Agree to Terms and Conditions</div></mat-checkbox>
          </div>
          @if (isUserLoggedIn) {
            <div>
              <button style="border-radius: 4px" [disabled]="!agreeToTermsForm.value || addToCartFormGroup.controls.appointmentTypeSelect.hasError('required') || addToCartFormGroup.controls.appointmentTypeSelect.pristine" mat-raised-button class="mr-2 mt-3 add-btn" color="primary" (click)="routeToStripePayment()">
                Buy Now
              </button>
              @if (message.length > 0) {
                <p class="mt-2 error">{{message}}</p>
              }
            </div>
          }
          @if (!isUserLoggedIn) {
            <div>
              <button mat-raised-button style="border-radius: 4px" class="mr-2 mt-3 add-btn" color="primary" (click)="routeToLogin()">
                Login to Buy
              </button>
            </div>
          }
        </div>
      }


      @if ((selectedServicePlan?.quantityAvailable == 0 && selectedServicePlan?.unlimitedQuantity == false) || subOutOfStock) {
        <h1 class="out-of-stock error mt-3">
          Out Of Stock
        </h1>
      }
    </div>
  </div>
</div>